var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.331h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M256 85.331h256v341.337H256z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M292.669 223.259l-14.003 19.295-22.677-7.353 14.024 19.28-14.002 19.296 22.671-7.381 14.025 19.28-.014-23.841 22.669-7.381-22.678-7.354z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.158 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.704-10.467-25.342-16.927-41.494-16.927-32.785 0-59.362 26.577-59.362 59.362s26.577 59.362 59.362 59.362c16.152 0 30.79-6.461 41.494-16.927a48.003 48.003 0 01-22.943 5.797z"
}))));

export default SvgDz;